class ShopScentCarousel extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.index = 0;
    this.scenes = [...this.querySelectorAll('[data-sts-scene]')];
    this.products = [...this.querySelectorAll('[data-sts-product]')];
    this.dots = [...this.querySelectorAll('[data-sts-go]')];
    this.stage = this.querySelector('[data-sts-scenes]');
    this.locked = false;

    this.addEventListener('click', (event) => {
      const dot = event.target.closest('[data-sts-go]');
      if (dot) this.select(Number(dot.dataset.stsGo));
      if (event.target.closest('[data-sts-prev]')) this.select(this.index - 1);
      if (event.target.closest('[data-sts-next]')) this.select(this.index + 1);
    });
    this.stage?.addEventListener('wheel', (event) => this.onWheel(event), { passive: false });
    this.stage?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown') { event.preventDefault(); this.select(this.index + 1); }
      if (event.key === 'ArrowUp') { event.preventDefault(); this.select(this.index - 1); }
    });
    this.stage?.addEventListener('pointerdown', (event) => { this.startY = event.clientY; });
    this.stage?.addEventListener('pointerup', (event) => {
      if (this.startY == null) return;
      const delta = event.clientY - this.startY;
      this.startY = null;
      if (Math.abs(delta) > 45) this.select(this.index + (delta < 0 ? 1 : -1));
    });
    this.select(0);
  }

  onWheel(event) {
    const direction = Math.sign(event.deltaY);
    const next = this.index + direction;
    if (!direction || next < 0 || next >= this.scenes.length) return;
    event.preventDefault();
    if (this.locked) return;
    this.locked = true;
    this.select(next);
    window.setTimeout(() => { this.locked = false; }, 700);
  }

  select(value) {
    const next = Math.max(0, Math.min(value, this.scenes.length - 1));
    this.index = next;
    this.scenes.forEach((scene, i) => {
      scene.classList.toggle('is-active', i === next);
      scene.classList.toggle('is-before', i < next);
      scene.classList.toggle('is-after', i > next);
      scene.setAttribute('aria-hidden', String(i !== next));
    });
    this.products.forEach((product, i) => {
      product.classList.toggle('is-active', i === next);
      product.setAttribute('aria-hidden', String(i !== next));
    });
    this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === next)));
  }
}

if (!customElements.get('shop-scent-carousel')) customElements.define('shop-scent-carousel', ShopScentCarousel);
